module.exports = __webpack_public_path__ + "img/hackbacklogo.fd74f711.svg";